export const DEMOASHADefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "Adolescent Health",
            "hi": "किशोर स्वास्थ्य",
            "or": "କିଶୋର ସ୍ୱାସ୍ଥ୍ୟ"
        },
        "img": "./Assets/Images/Adolescent.svg",
    },
    {
        "id": "2",
        "value": {
            "en": "Child Nutrition",
            "hi": "बाल पोषण",
            "or": "ଶିଶୁ ପୁଷ୍ଟିସାର",

        },
        "img": "./Assets/Images/Child Nutrition.svg",
    },
    {
        "id": "3",
        "value": {
            "en": "Emergency",
            "hi": "आपात स्थितियाँ",
            "or": "ଜରୁରୀକାଳୀନ",
        },
        "img": "./Assets/Images/Emergency.svg",
    },
    {
        "id": "4",
        "value": {
            "en": "Allergy",
            "hi": "एलर्जी",
            "or": "ଆଲର୍ଜି",
        },
        "img": "./Assets/Images/Allergy.svg",
    }
]

export const NHSRCASHADefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "Pregnancy",
            "hi": "गर्भावस्था",
            "or": "ଗର୍ଭାବସ୍ଥା",
        },
        "img": "./Assets/Images/pregnancy.svg",
    },
    {
        "id": "2",
        "value": {
            "en": "Tuberculosis",
            "hi": "टीबी",
            "or": "ଟିବି",

        },
        "img": "./Assets/Images/tuberculosis.svg",
    },
    {
        "id": "3",
        "value": {
            "en": "Child Health",
            "hi": "बाल स्वास्थ्य",
            "or": "ଶିଶୁ ସ୍ୱାସ୍ଥ୍ୟ",
        },
        "img": "./Assets/Images/NewbornNutrition.svg",
    },
    {
        "id": "4",
        "value": {
            "en": "Immunization",
            "hi": "टीकाकरण",
            "or": "ଟୀକାକରଣ",
        },
        "img": "./Assets/Images/vaccination.svg",
    }
]

export const WCDAWWDefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "Nutrition",
            "hi": "पोषण",
            "or": "ପୋଷଣ",
        },
        "img": "./Assets/Images/Chips/Nutrition.svg"
    },
    {
        "id": "2",
        "value": {
            "en": "Growth Monitoring",
            "hi": "ग्रोथ मॉनिटरिंग",
            "or": "Growth Monitoring",

        },
        "img": "./Assets/Images/Chips/Growth Monitoring.svg"
    },
    {
        "id": "3",
        "value": {
            "en": "Malnutrition",
            "hi": "कुपोषण",
            "or": "Malnutrition",
        },
        "img": "./Assets/Images/Chips/Malnutrition.svg"
    },
    {
        "id": "4",
        "value": {
            "en": "Anemia",
            "hi": "एनीमिया",
            "or": "ଅନିମିଆ",
        },
        "img": "./Assets/Images/Chips/Anemia.svg"
    },
    {
        "id": "5",
        "value": {
            "en": "Infant Feeding",
            "hi": "शिशु आहार",
            "or": "Infant Feeding",
        },
        "img": "./Assets/Images/Chips/Infant Feeding.svg"
    },
    {
        "id": "6",
        "value": {
            "en": "Complementary Feeding",
            "hi": "पूरक आहार",
            "or": "Complementary Feeding",
        },
        "img": "./Assets/Images/Chips/Complementary Feeding.svg"
    },
    {
        "id": "7",
        "value": {
            "en": "Newborn Care",
            "hi": "नवजात शिशु देखभाल",
            "or": "ନବଜାତ ଶିଶୁ ଯତ୍ନ",
        },
        "img": "./Assets/Images/Chips/Newborn Care.svg"
    },
    {
        "id": "8",
        "value": {
            "en": "ECCE",
            "hi": "ईसीसीई",
            "or": "ECCE",
        },
        "img": "./Assets/Images/Chips/ECCE.svg"
    },
]

export const CTDASHADefaultChipsList = [
    {
        "id": "1",
        "value": {"en": "100 Days Campaign", "hi": "100 दिन अभियान", "or": "୧୦୦ ଦିନିଆ ଅଭିଯାନ"},
        "img": null,
    },
    {
        "id": "2",
        "value": {"en": "Support to TB Patients", "hi": "टीबी मरीजों को समर्थन", "or": "ଯକ୍ଷ୍ମା ରୋଗୀଙ୍କୁ ସହାୟତା"},
        "img": null,
    },
    {
        "id": "3",
        "value": {"en": "Schemes & Incentives", "hi": "योजनाएं और इंसेंटिव", "or": "ଯୋଜନା ଏବଂ ପ୍ରୋତ୍ସାହନ"},
        "img": null,
    },
    {
        "id": "4",
        "value": {"en": "About TB", "hi": "टीबी के बारे में", "or": "ଯକ୍ଷ୍ମା ବିଷୟରେ"},
        "img": null,
    }
]

export const CTDCHODefaultChipsList = [
    {
        "id": "1",
        "value": {"en": "100 Days Campaign", "hi": "100 दिन अभियान", "or": "୧୦୦ ଦିନିଆ ଅଭିଯାନ"},
        "img": null,
    },
    {
        "id": "2",
        "value": {"en": "Support to TB Patients", "hi": "टीबी मरीजों को समर्थन", "or": "ଯକ୍ଷ୍ମା ରୋଗୀଙ୍କୁ ସହାୟତା"},
        "img": null,
    },
    {
        "id": "3",
        "value": {"en": "Patient Flow", "hi": "मरीजों की प्रक्रिया", "or": "ରୋଗୀ ପ୍ରବାହ"},
        "img": null,
    },
    {
        "id": "4",
        "value": {"en": "Nikshay", "hi": "निक्षय", "or": "ନିକ୍ଷୟ"},
        "img": null,
    }
]

export const GAVIASHADefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "Maternal Health",
            "hi": "मातृ स्वास्थ्य",
            "or": "ମାତୃ ସ୍ୱାସ୍ଥ୍ୟ",
        },
        "img": "./Assets/Images/Chips/Maternal Health.svg",
    },
    {
        "id": "2",
        "value": {
            "en": "Newborn Care",
            "hi": "नवजात शिशु की देखभाल",
            "or": "ନବଜାତ ଶିଶୁ ଯତ୍ନ",

        },
        "img": "./Assets/Images/Chips/Newborn Care.svg",
    },
    {
        "id": "3",
        "value": {
            "en": "Child Health",
            "hi": "बाल स्वास्थ्य",
            "or": "ଶିଶୁ ସ୍ୱାସ୍ଥ୍ୟ",
        },
        "img": "./Assets/Images/Chips/Child Health.svg",
    },
    {
        "id": "4",
        "value": {
            "en": "Nutrition",
            "hi": "पोषण",
            "or": "ପୋଷଣ",
        },
        "img": "./Assets/Images/Chips/Nutrition.svg",
    },
    {
        "id": "5",
        "value": {
            "en": "Immunization",
            "hi": "टीकाकरण",
            "or": "ଟିକାକରଣ",
        },
        "img": "./Assets/Images/Chips/Immunization.svg",
    },
    {
        "id": "6",
        "value": {
            "en": "Family Planning",
            "hi": "परिवार नियोजन",
            "or": "ପରିବାର ପରିକଳ୍ପନା",
        },
        "img": "./Assets/Images/Chips/Family Planning.svg",
    },
    {
        "id": "7",
        "value": {
            "en": "NCDs",
            "hi": "एनसीडी",
            "or": "ଏନ୍‌ସିଡିସ୍",
        },
        "img": "./Assets/Images/Chips/NCDs.svg",
    },
    {
        "id": "8",
        "value": {
            "en": "Anemia",
            "hi": "एनीमिया",
            "or": "ଅନିମିଆ",
        },
        "img": "./Assets/Images/Chips/Anemia.svg",
    }
]

export const BSHSFPCDefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "Oral Contraceptive Pills (OCP)",
            "hi": "मौखिक गर्भनिरोधक गोलियाँ (ओसीपी)",
            "or": "ମୌଖିକ ଗର୍ଭନିରୋଧକ ବଟିକା (OCP)",
        },
        "img": "./Assets/Images/Oral_Contraceptives.svg",
    },
    {
        "id": "2",
        "value": {
            "en": "PPIUCD",
            "hi": "पीपीआईयूसीडी",
            "or": "PPIUCD",

        },
        "img": "./Assets/Images/PPUCD.svg",
    },
    {
        "id": "3",
        "value": {
            "en": "DMPA",
            "hi": "डीएमपीए",
            "or": "DMPA",
        },
        "img": "./Assets/Images/DMPA.svg",
    },
    {
        "id": "4",
        "value": {
            "en": "Myths & Facts",
            "hi": "मिथक और तथ्य",
            "or": "ମିଥ୍ୟା ଏବଂ ତଥ୍ୟ",
        },
        "img": "./Assets/Images/Myths_and_Facts.svg",
    }
]

export const POCANMDefaultChipsList = [
    {
        "id": "1",
        "value": {
            "en": "VHSND",
            "hi": "वीएचएसएनडी",
            "or": "VHSND",
        },
        "img": "./Assets/Images/VHSND.svg",
    },
    {
        "id": "2",
        "value": {
            "en": "Cold Chain",
            "hi": "कोल्ड चेन",
            "or": "ଶୀତ ଶୃଙ୍ଖଳା",

        },
        "img": "./Assets/Images/Cold_Chain.svg",
    },
    {
        "id": "3",
        "value": {
            "en": "VPDs",
            "hi": "वी पी डी",
            "or": "VPD"
        },
        "img": "./Assets/Images/VPDs.svg",
    },
    {
        "id": "4",
        "value": {
            "en": "PMSMA",
            "hi": "पीएमएसएमए",
            "or": "PMSMA"
        },
        "img": "./Assets/Images/PMSMA.svg",
    }
];

export const bgColorChips = [
    'var(--accent-peach)',
    'var(--accent-lavender)',
    'var(--accent-amber)',
    'var(--accent-lilac)',
    'var(--accent-mint)',
    'var(--accent-rose)',
    'var(--accent-apricot)',
    'var(--accent-periwinkle)',
];
export const borderColorChips = [
    'var(--border-peach)',
    'var(--border-lavender)',
    'var(--border-amber)',
    'var(--border-lilac)',
    'var(--border-mint)',
    'var(--border-rose)',
    'var(--border-apricot)',
    'var(--border-periwinkle)',
];
  export const textColor = [
    'var(--text-peach)',
    'var(--text-lavender)',
    'var(--text-amber)',
    'var(--text-lilac)',
    'var(--text-mint)',
    'var(--text-rose)',
    'var(--text-apricot)',
    'var(--text-periwinkle)',
];